import React, { useMemo, useCallback } from 'react';
import { observer } from 'mobx-react';
import { useLocation, useHistory } from 'react-router-dom';
import SuppliedItemMappingTabs from '@this/components/admin/supplied_item_mappings/share/supplied_item_mapping_tabs';
import { RadioGroup, Radio } from '@this/components/shared/ui/inputs/radio';
import TicketingMethodMapping from './ticketing_method_mapping';
import RailwayAreas from './railway_areas';
import Prefectures from './prefectures';
import { Title } from '../../admin';
import { AdminContentIn } from '../../shared/atom';

const SUB_TABS = [
  { key: 'ticketing_method', label: '発券方法マッピング' },
  { key: 'railway_areas', label: '鉄道エリア' },
  { key: 'prefectures', label: '都道府県' }
];

const IndividualRailwaySuppliedItems = () => {
  const location = useLocation();
  const history = useHistory();

  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const currentSubTab = searchParams.get('sub_tab') || 'ticketing_method';
  const isIndividualRailwaySelected =
    location.pathname === '/admin/individual_railway_supplied_items' ||
    searchParams.get('tab') === 'individual_railway_supplied_items';

  const handleSubTabChange = useCallback(
    (subTab: string) => {
      const params = new URLSearchParams(location.search);
      params.set('tab', 'individual_railway_supplied_items');
      params.set('sub_tab', subTab);
      history.push(`${location.pathname}?${params.toString()}`);
    },
    [history, location.pathname, location.search]
  );

  return (
    <div>
      <Title>仕入商品マッピング</Title>
      <AdminContentIn>
        <div style={{ marginBottom: '40px' }}>個別にデフォルトの仕入商品を設定できます。</div>
        <SuppliedItemMappingTabs />
        {isIndividualRailwaySelected && (
          <>
            <RadioGroup
              layout="horizontal"
              value={currentSubTab}
              onChange={e => handleSubTabChange(e.target.value)}
              style={{ marginBottom: '20px' }}
            >
              {SUB_TABS.map(({ key, label }) => (
                <Radio key={key} value={key}>
                  {label}
                </Radio>
              ))}
            </RadioGroup>
            {currentSubTab === 'ticketing_method' ? (
              <TicketingMethodMapping />
            ) : currentSubTab === 'railway_areas' ? (
              <RailwayAreas />
            ) : currentSubTab === 'prefectures' ? (
              <Prefectures />
            ) : null}
          </>
        )}
      </AdminContentIn>
    </div>
  );
};

export default observer(IndividualRailwaySuppliedItems);
